<template>
  <div class="content">
    <h1>User Menu</h1>
    <button
      v-for="tab in tabs"
      :key="tab"
      class="p-2 px-10 m-2 font-bold rounded-full"
      :class="['tab-button', { active: currentTab === tab }]"
      @click="currentTab = tab"
    >
      {{ tab }}
    </button>
    <component
      :is="currentTabComponent"
      :email="email"
      class="tab-content"
      @add_admin="handleAdd"
      @edit_admin="handleEdit"
    ></component>
  </div>
</template>

<script>
import AddUserToCohort from "@/components/addUserToCohort/AddUserToCohort"
import RemoveUserFromCohort from "@/components/removeUserFromCohort/RemoveUserFromCohort"
import FetchUserDetails from "@/components/fetchUserDetails/FetchUserDetails"
import UserNotifications from "@/components/userNotifications/UserNotifications"
import UserFullStory from "@/components/userFullStory/UserFullStory"
import UserForms from "@/components/userForms/UserForms"
import AssignmentAttempt from "@/components/addAssignmentAttempt/AssignmentAttempt"
import ResetContest from "@/components/resetContest/ResetContest"
import AddLegacyUser from "@/components/legacyuser/AddLegacyUser"
import AddEditCollegeAdmin from "@/components/CollegeAdminRoles/AddEditCollegeAdmin"
import UserList from "@/components/user/UserList"
import EditLegacyUser from "@/components/legacyuser/EditLegacyUser"
import ResetUserFromCohort from "@/components/resetUserFromCohort/ResetUserFromCohort"
import AssignUserInvitation from "@/components/assignUserInvitation/AssignUserInvitation"
import AddUserToQuestionBankCohort from "@/components/addUserToQuestionBankCohort/AddUserToQuestionBankCohort"

export default {
  components: {
    AddUserToCohort,
    RemoveUserFromCohort,
    FetchUserDetails,
    UserNotifications,
    UserFullStory,
    UserForms,
    AssignmentAttempt,
    AddLegacyUser,
    AddEditCollegeAdmin,
    EditLegacyUser,
    UserList,
    AddUserToQuestionBankCohort,
  },
  data() {
    return {
      email: "",
      currentTab: "Add To Cohort",
      tabs: [
        "Add To Cohort",
        "Add To Question Bank Cohort",
        "Reset",
        "Fetch User Details",
        "Email Notifications",
        "Full Story Sessions",
        "Add User Forms",
        "Add Assignment Attempt",
        "Reset Contest Attempt",
        "Add Legacy User",
        "Edit Legacy User",
        "Add/Edit College Admin",
        "List College Admins",
        "Reset User Progress",
        "Assign User Invitation",
      ],
      tabToComponent: {
        "Add To Cohort": AddUserToCohort,
        "Add To Question Bank Cohort": AddUserToQuestionBankCohort,
        Reset: RemoveUserFromCohort,
        "Fetch User Details": FetchUserDetails,
        "Email Notifications": UserNotifications,
        "Full Story Sessions": UserFullStory,
        "Add User Forms": UserForms,
        "Add Assignment Attempt": AssignmentAttempt,
        "Reset Contest Attempt": ResetContest,
        "Add Legacy User": AddLegacyUser,
        "Edit Legacy User": EditLegacyUser,
        "Add/Edit College Admin": AddEditCollegeAdmin,
        "List College Admins": UserList,
        "Reset User Progress": ResetUserFromCohort,
        "Assign User Invitation": AssignUserInvitation,
      },
    }
  },
  computed: {
    currentTabComponent() {
      return this.tabToComponent[this.currentTab]
    },
  },
  created() {
    /* reusing the same component for community manager route
    we do not display all the tabs for community manger admin */
    const routeName = this.$route.name
    if (routeName === "CommunityManagerAdminPage") {
      this.tabs = [
        "Add To Cohort",
        "Fetch User Details",
        "Add Assignment Attempt",
        "Reset Contest Attempt",
        "Add/Edit College Admin",
        "List College Admins",
      ]
    }
  },
  methods: {
    handleAdd() {
      this.currentTab = "Add/Edit College Admin"
    },

    handleEdit(email) {
      this.email = email
      this.currentTab = "Add/Edit College Admin"
    },
  },
}
</script>

<style scoped>
.content {
  text-align: center;
}
.tab-button {
  margin-right: -1px;
  border: 1px solid #536dfa;
  outline: none;
  color: #536dfa;
  background: #fff;
  cursor: pointer;
}
.tab-button:hover,
.tab-button.active {
  color: #fff;
  background: #536dfa;
}
.tab-content {
  padding: 10px;
  border: 1px solid #ccc;
}
</style>
